import axios from '../shared/axios';
import * as events from './events';

export function savePaymentCertificate(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/PaymentCertificate/SavePaymentCertificate`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}

export function updatePaymentCertificate(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/PaymentCertificate/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function getPaymentCertificate(paymentcertificateid) {
    return axios.get(`/api/PaymentCertificate/GetPaymentCertificateV2?earlypaymentcertificateid=${paymentcertificateid}`);
}

export function getPaymentCertificates(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/PaymentCertificate/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
}
export function deletePaymentCertificateDraft(paymentcertificateid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/PaymentCertificate/DeleteDraft?paymentcertificateid=${paymentcertificateid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}

export function getLastPaymentAmounts(contractid, paymentTypes, currencyCodes, projectOrderIds) {
    return axios.post(`/api/PaymentCertificate/GetLastPaymentAmounts`, { contractid, paymentTypes, currencyCodes, projectOrderIds });
}

export function importPaymentCertificates(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/PaymentCertificate/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deletePaymentCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/PaymentCertificate/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicatePaymentCertificateDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/PaymentCertificate/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}